module.exports = __webpack_public_path__ + "assets/img/cy.2198b851.png";